import React, { useEffect, useMemo, useState } from "react";
import baseUrl from "../../../../../api/baseUrl";
import OHTd from "./OHTd";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function OpeningH({ timeData }: any) {
  const [currentDate, setcurrentDate] = useState(new Date());

  const weekArray = useMemo(() => {
    const startDate = new Date(currentDate);
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
    const array = [];

    let currentDateIteration = new Date(startDate);
    while (currentDateIteration <= endDate) {
      const options: any = { month: "numeric", day: "numeric" };
      if (window.innerWidth > 500) options.year = "numeric";
      const fullDate = currentDateIteration.toLocaleDateString("en-US", options);
      const weekDay = currentDateIteration.toLocaleDateString("en-US", {
        weekday: window.innerWidth > 500 ? "long" : "short",
      });
      const actDate = currentDateIteration.toISOString().slice(0, 10);
      const standTime = new Date(currentDateIteration);
      standTime.setUTCHours(0, 0, 0, 0);
      array.push({ week: weekDay, date: fullDate, activeDate: standTime, actDate });
      currentDateIteration.setDate(currentDateIteration.getDate() + 1);
    }
    return array;
  }, [currentDate]);

  const [dentalActiveDays, setdentalActiveDays] = useState([]);
  const [dentalDeactiveDateTime, setdentalDeactiveDateTime] = useState([]);

  useEffect(() => {
    baseUrl
      .get("/managetime/getHours")
      .then((response) => {
        setdentalActiveDays(response.data.openHoursGeneral);
        setdentalDeactiveDateTime(response.data.openHours);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleGeneralHours = (e: any) => {
    baseUrl
      .post("/managetime/openHours", e)
      .then((response) => {})
      .catch((error) => {
        console.log(error);
      });
  };

  const [edit, setedit] = useState(false);

  const onEdit = () => {
    if (edit) {
      window.location.reload();
    } else {
      setedit(!edit);
    }
  };

  const handleLeftArrow = () => {
    const futureDate = new Date(currentDate);
    futureDate.setDate(currentDate.getDate() - 7);
    setcurrentDate(futureDate);
  };

  const handleRightArrow = () => {
    const futureDate = new Date(currentDate);
    futureDate.setDate(currentDate.getDate() + 7);
    setcurrentDate(futureDate);
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-100 overflow-hidden">
      <div className="px-6 py-4 border-b border-slate-100 flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center">
            <AccessTimeIcon className="text-white" sx={{ fontSize: 20 }} />
          </div>
          <h3 className="text-lg font-bold text-slate-800">Opening Hours</h3>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 bg-slate-100 rounded-lg p-1">
            <button
              onClick={() => handleLeftArrow()}
              className="w-8 h-8 rounded-lg hover:bg-white hover:shadow-sm flex items-center justify-center transition-all"
            >
              <ChevronLeftIcon sx={{ fontSize: 20 }} />
            </button>
            <button
              onClick={() => handleRightArrow()}
              className="w-8 h-8 rounded-lg hover:bg-white hover:shadow-sm flex items-center justify-center transition-all"
            >
              <ChevronRightIcon sx={{ fontSize: 20 }} />
            </button>
          </div>
          <button
            onClick={() => onEdit()}
            className={`flex items-center gap-2 px-4 py-2 rounded-xl font-medium transition-all ${
              edit
                ? "bg-blue-500 text-white hover:bg-blue-600"
                : "bg-slate-100 text-slate-600 hover:bg-slate-200"
            }`}
          >
            {edit ? <SaveIcon sx={{ fontSize: 18 }} /> : <EditIcon sx={{ fontSize: 18 }} />}
            {edit ? "Save" : "Edit"}
          </button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50/80">
              <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider min-w-[80px]">
                Time
              </th>
              {weekArray.map((day: any, index: number) => (
                <th
                  key={index}
                  className="px-2 py-3 text-center text-xs font-semibold text-slate-500 uppercase tracking-wider"
                >
                  <div>{day.week}</div>
                  <div className="text-slate-400 font-normal">{day.date}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {timeData?.map((time: any, index: number) => (
              <tr key={index} className="hover:bg-slate-50/50">
                <td className="px-4 py-2 text-sm font-medium text-slate-600">
                  {time?.formattedTime}
                </td>
                {weekArray.map((day: any, idx: number) => (
                  <OHTd
                    key={idx}
                    edit={edit}
                    dataHeader={{
                      day: day?.week,
                      startTime: time?.startTime,
                      endTime: time?.endTime,
                      interval: time?.interval,
                      date: day?.date,
                      fullDate: day?.activeDate,
                      activeDate: day?.actDate,
                    }}
                    onClick={handleGeneralHours}
                    activeTime={
                      dentalActiveDays?.filter(
                        (item: any) =>
                          item?.day === day?.week &&
                          item?.startTime === time?.startTime &&
                          item?.endTime === time?.endTime
                      ).length === 1
                    }
                    deactiveTime={
                      dentalDeactiveDateTime?.filter(
                        (item: any) =>
                          item?.day === day?.week &&
                          item?.startTime === time?.startTime &&
                          item?.endTime === time?.endTime &&
                          item?.fullDate?.split("T")[0] === day?.actDate
                      ).length === 1
                    }
                  />
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default OpeningH;
